"use client";

import React from "react";

/**
 * Skeleton rows shown while a query is in flight. One row matches the
 * approximate height of a real SearchResultItem (icon + title + metadata
 * line) so the list doesn't jump when results land.
 *
 * Kept CSS-minimal: a Tailwind `animate-pulse` on three grey bars per
 * row. No shimmer library needed.
 */
export function SearchSkeletonList({ count = 6 }: { count?: number }) {
  return (
    <div className="flex flex-col">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonRow key={i} />
      ))}
    </div>
  );
}

function SkeletonRow() {
  return (
    <div className="flex items-start gap-3 rounded-xl px-3 py-2">
      <div className="mt-0.5 h-5 w-5 shrink-0 rounded bg-gray-200 dark:bg-[rgb(42,42,42)] animate-pulse" />
      <div className="min-w-0 flex-1">
        <div className="h-3.5 w-2/3 rounded bg-gray-200 dark:bg-[rgb(42,42,42)] animate-pulse" />
        <div className="mt-2 h-3 w-1/3 rounded bg-gray-200/70 dark:bg-[rgb(42,42,42)]/70 animate-pulse" />
      </div>
    </div>
  );
}

/**
 * Smaller skeleton — three bars — used inline next to a section header
 * (matches the "Today · Loading…" look more closely).
 */
export function SectionHeaderSkeleton() {
  return (
    <div className="flex items-center gap-1.5">
      <div className="h-3 w-3 rounded-full border-2 border-component border-t-foreground/40 animate-spin" />
      <span className="text-xs text-muted-foreground">Loading…</span>
    </div>
  );
}
